import { render, staticRenderFns } from "./editVehicleChallan.vue?vue&type=template&id=5774af91"
import script from "./editVehicleChallan.vue?vue&type=script&lang=js"
export * from "./editVehicleChallan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports